import script from "./ResourceManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ResourceManagement.vue?vue&type=script&setup=true&lang=js"

import "./ResourceManagement.vue?vue&type=style&index=0&id=042ed806&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-042ed806"]])

export default __exports__